import React from "react";
import { Link } from "react-router-dom";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import {
  generateBreadcrumbStructuredData,
  generateWebPageStructuredData,
} from "../../components/SEO/StructuredData";
import { AI_ASSIST_IMPORTS, AI_ASSIST_PAGE } from "../../utility/aiAssistCopy";

const BowlingTournamentAiAssist = () => (
  <ProductPage
    title={AI_ASSIST_PAGE.title}
    description={AI_ASSIST_PAGE.description}
    keywords={[
      "bowling tournament AI assist",
      "AI bowling tournament software",
      "import league averages from a photo",
      "paper signup sheet bowling tournament",
      "AI recap sheet bowling",
    ]}
    canonicalUrl={AI_ASSIST_PAGE.to}
    kicker="AI Assist"
    heading={AI_ASSIST_PAGE.heading}
    lede={AI_ASSIST_PAGE.lede}
    analyticsLocation="product_ai_assist"
    secondaryTo="/pricing"
    secondaryLabel="Plans"
    showNextStep={false}
    structuredData={generateWebPageStructuredData({
      name: AI_ASSIST_PAGE.title,
      description: AI_ASSIST_PAGE.description,
      url: AI_ASSIST_PAGE.to,
      dateModified: "2026-11-04",
    })}
    additionalStructuredData={[
      generateBreadcrumbStructuredData([
        { label: "Home", path: "/" },
        { label: "AI Assist", path: AI_ASSIST_PAGE.to },
      ]),
    ]}
  >
    <div className="space-y-16 max-w-4xl">
      {AI_ASSIST_IMPORTS.map((row) => {
        const shot = PRODUCT_SCREENSHOTS[row.shotKey];
        return (
          <section key={row.id}>
            <h2 className="font-display font-bold tracking-tight text-2xl md:text-3xl text-brand-charcoal">
              {row.landingHeading}
            </h2>
            <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
            <p className="mt-4 text-brand-charcoal leading-relaxed">
              {row.heading}
            </p>
            <p className="mt-3 text-brand-muted leading-relaxed">{row.fix}</p>
            <p className="mt-4">
              <Link to={row.to} className="underline text-brand-gold-ink">
                {row.label}
              </Link>
            </p>
            {shot ? (
              <figure className="mt-6 card-board overflow-hidden">
                <img
                  src={shot.src}
                  alt={shot.alt}
                  className="w-full h-auto bg-white"
                  width={1600}
                  height={1000}
                />
              </figure>
            ) : null}
          </section>
        );
      })}
      <section>
        <h2 className="font-display font-bold tracking-tight text-2xl md:text-3xl text-brand-charcoal">
          Free on your first tournament
        </h2>
        <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
        <p className="mt-4 text-brand-muted leading-relaxed max-w-2xl">
          AI Assist is free on your first tournament, then $99/year for up to
          20 tournaments.
        </p>
        <p className="mt-4">
          <Link to="/pricing" className="underline text-brand-gold-ink">
            Plans
          </Link>
        </p>
      </section>
    </div>
  </ProductPage>
);

export default BowlingTournamentAiAssist;
